(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"./src/public/logged-out-mobile.js":[function(require,module,exports){
/* global jQuery */
'use strict';

require('module-tsl-ui-components/components/carousel-bullets/carousel-bullets');

jQuery('.js-carousel-bullets').carouselBullets();

},{"module-tsl-ui-components/components/carousel-bullets/carousel-bullets":"/root/app-home/node_modules/module-tsl-ui-components/components/carousel-bullets/carousel-bullets.js"}],"/root/app-home/node_modules/browserify/lib/_empty.js":[function(require,module,exports){

},{}],"/root/app-home/node_modules/module-tsl-ui-components/components/carousel-bullets/carousel-bullets.js":[function(require,module,exports){
'use strict';

require('swipe-js');

if (jQuery) {
  jQuery.fn.carouselBullets = function (params) {
    var opts = params || {};
    return this.each(function () {
      jQuery(this).Swipe({
        auto: opts.auto || 0,
        autoRestart: false,
        bulletWrapperClass: 'js-carousel-bullets-nav',
        bulletClass: 'carousel-bullets__nav-bullet'
      });
    });
  };
}

},{"swipe-js":"/root/app-home/node_modules/swipe-js/swipe.js"}],"/root/app-home/node_modules/swipe-js/swipe.js":[function(require,module,exports){
/*
 * Swipe 2.0
 *
 * Brad Birdsall and Xiuyu Li
 * Copyright 2015, MIT License
 *
 */

function Swipe(container, options) {

  "use strict";

  // utilities
  var noop = function() {}; // simple no operation function
  var offloadFn = function(fn) { setTimeout(fn || noop, 0) }; // offload a functions execution

  // check browser capabilities
  var browser = {
    addEventListener: !!window.addEventListener,
    touch: ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch,
    transitions: (function(temp) {
      var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];
      for ( var i in props ) if (temp.style[ props[i] ] !== undefined) return true;
      return false;
    })(document.createElement('swipe'))
  };

  // quit if no root element
  if (!container) return;
  var element = container.children[0];
  var slides, slidePos, width, length;
  options = options || {};
  options.bulletWrapperClass = options.bulletWrapperClass ? '.' + options.bulletWrapperClass : '';
  var bulletWrapper = options.bulletWrapperClass || null;
  var bulletClass = options.bulletClass || 'swipe-bullet';
  var activeBulletClass = options.bulletActiveClass || 'active';
  var index = parseInt(options.startSlide, 10) || 0;
  var position = index;
  var clonedSlides = false;
  var speed = options.speed || 300;
  options.continuous = options.continuous !== undefined ? options.continuous : true;

  // AutoRestart option: auto restart slideshow after user's touch event
  options.autoRestart = options.autoRestart !== undefined ? options.autoRestart : true;

  //add a css class to a dom element
  function addClassToElem(elem,value){
    var rspaces = /\s+/;
    var classNames = (value || "").split( rspaces );
    var className = " " + elem.className + " ",
      setClass = elem.className;
    for ( var c = 0, cl = classNames.length; c < cl; c++ ) {

      if ( className.indexOf( " " + classNames[c] + " " ) < 0 ) {
        setClass += " " + classNames[c];
      }

    }
    elem.className = setClass.replace(/^\s+|\s+$/g,''); //trim
  }

  //remove a css class from a dom element
  function removeClassFromElem(elem,value){
    var rspaces = /\s+/;
    var rclass = /[\n\t]/g
    var classNames = (value || "").split( rspaces );
    var className = (" " + elem.className + " ").replace(rclass, " ");

    for ( var c = 0, cl = classNames.length; c < cl; c++ ) {
      className = className.replace(" " + classNames[c] + " ", " ");
    }

    elem.className = className.replace(/^\s+|\s+$/g,''); //trim
  }


  function addEventHandler(elem,eventType,handler) {
    if (elem.addEventListener)
      elem.addEventListener (eventType,handler,false);
    else if (elem.attachEvent)
      elem.attachEvent ('on'+eventType,handler);
  }

  // get the target of a click event, we need this so we have support for multiple browsers
  function getTarget(e) {
    var clickTarget;
    if (e.target) clickTarget = e.target;
    else if (e.srcElement) clickTarget = e.srcElement;
    if (clickTarget.nodeType == 3) // defeat Safari bug
      clickTarget = clickTarget.parentNode;

    return clickTarget;
  }

  function setup() {

    // cache slides
    slides = element.children;
    length = slides.length;

    // set continuous to false if only one slide
    if (slides.length < 2) options.continuous = false;

    //special case if two slides
    if (browser.transitions && options.continuous && slides.length < 3) {
      element.appendChild(slides[0].cloneNode(true));
      element.appendChild(element.children[1].cloneNode(true));
      slides = element.children;
      clonedSlides = true;
    }

    // create an array to store current positions of each slide
    slidePos = new Array(slides.length);

    // determine width of each slide
    width = container.getBoundingClientRect().width || container.offsetWidth;

    element.style.width = (slides.length * width) + 'px';

    // stack elements
    var pos = slides.length;

    if (bulletWrapper != null) {

      var bulletWrapperObj = container.querySelector(bulletWrapper);
      var bulletInc = 0;
      bulletWrapperObj.innerHTML = '';

    }

    while(pos--) {

      var slide = slides[pos];

      slide.style.width = width + 'px';
      slide.setAttribute('data-index', pos);

      if (clonedSlides === false || pos <= 1) {
        if (bulletWrapperObj) {
          bulletWrapperObj.innerHTML += '<a class="' + bulletClass + '" href="#">' + bulletInc + '</a>';
          bulletInc++;
        }
      }

      if (browser.transitions) {
        slide.style.left = (pos * -width) + 'px';
        move(pos, index > pos ? -width : (index < pos ? width : 0), 0);
      }

    }

    // reposition elements before and after index
    if (options.continuous && browser.transitions) {
      move(circle(index-1), -width, 0);
      move(circle(index+1), width, 0);
    }

    if (!browser.transitions) element.style.left = (index * -width) + 'px';

    container.style.visibility = 'visible';
    container.className = container.className + ' initialised';

    // Need to highlight the bullet assigned to the current slide
    // the setup function is called on window resize so we cant highlight the first bullet but the current index
    hightlightCurrentBullet(index);
  }

  function hightlightCurrentBullet(to){
    if (bulletWrapper){

      var bulletWrapperObj = container.querySelector(bulletWrapper);
      var childObj = bulletWrapperObj.childNodes;

      for (var i=0;i<childObj.length;i++) {
        removeClassFromElem(childObj[i], "active");
      }
      addClassToElem(childObj[to], "active");
    }
  }

  function prev() {

    if (options.continuous) slide(index-1);
    else if (index) slide(index-1);

  }

  function next() {

    if (options.continuous) slide(index+1);
    else if (index < slides.length - 1) slide(index+1);

  }

  function circle(index) {

    // a simple positive modulo using slides.length
    return (slides.length + (index % slides.length)) % slides.length;

  }

  function slide(to, slideSpeed) {

    // do nothing if already on requested slide
    if (index == to) return;

    if (browser.transitions) {

      var direction = Math.abs(index-to) / (index-to); // 1: backward, -1: forward

      // get the actual position of the slide
      if (options.continuous) {
        var natural_direction = direction;
        direction = -slidePos[circle(to)] / width;

        // if going forward but to < index, use to = slides.length + to
        // if going backward but to > index, use to = -slides.length + to
        if (direction !== natural_direction) to =  -direction * slides.length + to;

      }

      var diff = Math.abs(index-to) - 1;

      // move all the slides between index and to in the right direction
      while (diff--) move( circle((to > index ? to : index) - diff - 1), width * direction, 0);

      to = circle(to);

      move(index, width * direction, slideSpeed || speed);
      move(to, 0, slideSpeed || speed);

      if (options.continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place

    } else {

      to = circle(to);
      animate(index * -width, to * -width, slideSpeed || speed);
      //no fallback for a circular continuous if the browser does not accept transitions
    }

    index = to;

    position = clonedSlides ? (index % 2) : index;

    // Highlighting the current slide bullet
    hightlightCurrentBullet(position);

    offloadFn(options.callback && options.callback(position, slides[index]));
  }

  function move(index, dist, speed) {

    translate(index, dist, speed);
    slidePos[index] = dist;

  }

  function translate(index, dist, speed) {

    var slide = slides[index];
    var style = slide && slide.style;

    if (!style) return;

    style.webkitTransitionDuration =
      style.MozTransitionDuration =
        style.msTransitionDuration =
          style.OTransitionDuration =
            style.transitionDuration = speed + 'ms';

    style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
    style.msTransform =
      style.MozTransform =
        style.OTransform = 'translateX(' + dist + 'px)';

  }

  function animate(from, to, speed) {

    // if not an animation, just reposition
    if (!speed) {

      element.style.left = to + 'px';
      return;

    }

    var start = +new Date;

    var timer = setInterval(function() {

      var timeElap = +new Date - start;

      if (timeElap > speed) {

        element.style.left = to + 'px';

        if (delay) begin();

        options.transitionEnd && options.transitionEnd.call(event, position, slides[index]);

        clearInterval(timer);
        return;

      }

      element.style.left = (( (to - from) * (Math.floor((timeElap / speed) * 100) / 100) ) + from) + 'px';

    }, 4);

  }

  // setup auto slideshow
  var delay = options.auto || 0;
  var interval;

  function begin() {

    interval = setTimeout(next, delay);

  }

  function stop() {

    delay = 0;
    clearTimeout(interval);

  }

  function restart() {
    stop();
    delay = options.auto || 0;
    begin();
  }

  // setup initial vars
  var start = {};
  var delta = {};
  var isScrolling;

  // setup event capturing
  var events = {

    handleEvent: function(event) {

      switch (event.type) {
        case 'touchstart': this.start(event); break;
        case 'touchmove': this.move(event); break;
        case 'touchend': offloadFn(this.end(event)); break;
        case 'webkitTransitionEnd':
        case 'msTransitionEnd':
        case 'oTransitionEnd':
        case 'otransitionend':
        case 'transitionend': offloadFn(this.transitionEnd(event)); break;
        case 'resize': offloadFn(setup); break;
      }

      if (options.stopPropagation) event.stopPropagation();

    },
    start: function(event) {

      var touches = event.touches[0];

      // measure start values
      start = {

        // get initial touch coords
        x: touches.pageX,
        y: touches.pageY,

        // store time to determine touch duration
        time: +new Date

      };

      // used for testing first move event
      isScrolling = undefined;

      // reset delta and end measurements
      delta = {};

      // attach touchmove and touchend listeners
      element.addEventListener('touchmove', this, false);
      element.addEventListener('touchend', this, false);

    },
    move: function(event) {

      // ensure swiping with one touch and not pinching
      if ( event.touches.length > 1 || event.scale && event.scale !== 1) return

      if (options.disableScroll) event.preventDefault();

      var touches = event.touches[0];

      // measure change in x and y
      delta = {
        x: touches.pageX - start.x,
        y: touches.pageY - start.y
      };

      // determine if scrolling test has run - one time test
      if ( typeof isScrolling === 'undefined') {
        isScrolling = !!( isScrolling || Math.abs(delta.x) < Math.abs(delta.y) );
      }

      // if user is not trying to scroll vertically
      if (!isScrolling) {

        // prevent native scrolling
        event.preventDefault();

        // stop slideshow
        stop();

        // increase resistance if first or last slide
        if (options.continuous) { // we don't add resistance at the end

          translate(circle(index-1), delta.x + slidePos[circle(index-1)], 0);
          translate(index, delta.x + slidePos[index], 0);
          translate(circle(index+1), delta.x + slidePos[circle(index+1)], 0);

        } else {

          delta.x =
            delta.x /
            ( (!index && delta.x > 0               // if first slide and sliding left
              || index == slides.length - 1        // or if last slide and sliding right
              && delta.x < 0                       // and if sliding at all
            ) ?
              ( Math.abs(delta.x) / width + 1 )      // determine resistance level
              : 1 );                                 // no resistance if false

          // translate 1:1
          translate(index-1, delta.x + slidePos[index-1], 0);
          translate(index, delta.x + slidePos[index], 0);
          translate(index+1, delta.x + slidePos[index+1], 0);
        }

      }

    },
    end: function(event) {

      // measure duration
      var duration = +new Date - start.time;

      // determine if slide attempt triggers next/prev slide
      var isValidSlide =
        Number(duration) < 250               // if slide duration is less than 250ms
        && Math.abs(delta.x) > 20            // and if slide amt is greater than 20px
        || Math.abs(delta.x) > width/2;      // or if slide amt is greater than half the width

      // determine if slide attempt is past start and end
      var isPastBounds =
        !index && delta.x > 0                            // if first slide and slide amt is greater than 0
        || index == slides.length - 1 && delta.x < 0;    // or if last slide and slide amt is less than 0

      if (options.continuous) isPastBounds = false;

      // determine direction of swipe (true:right, false:left)
      var direction = delta.x < 0;

      // if not scrolling vertically
      if (!isScrolling) {

        if (isValidSlide && !isPastBounds) {

          if (direction) {

            if (options.continuous) { // we need to get the next in this direction in place

              move(circle(index-1), -width, 0);
              move(circle(index+2), width, 0);

            } else {
              move(index-1, -width, 0);
            }

            move(index, slidePos[index]-width, speed);
            move(circle(index+1), slidePos[circle(index+1)]-width, speed);
            index = circle(index+1);

          } else {
            if (options.continuous) { // we need to get the next in this direction in place

              move(circle(index+1), width, 0);
              move(circle(index-2), -width, 0);

            } else {
              move(index+1, width, 0);
            }

            move(index, slidePos[index]+width, speed);
            move(circle(index-1), slidePos[circle(index-1)]+width, speed);
            index = circle(index-1);

          }

          position = clonedSlides ? (index % 2) : index;
          options.callback && options.callback(position, slides[index]);

        } else {

          if (options.continuous) {

            move(circle(index-1), -width, speed);
            move(index, 0, speed);
            move(circle(index+1), width, speed);

          } else {

            move(index-1, -width, speed);
            move(index, 0, speed);
            move(index+1, width, speed);
          }

        }

      }

      // kill touchmove and touchend event listeners until touchstart called again
      element.removeEventListener('touchmove', events, false)
      element.removeEventListener('touchend', events, false)

      // we need to highlight the bullet when we swipe the slide, not just on next or prev
      hightlightCurrentBullet(index);
    },
    transitionEnd: function(event) {

      if (parseInt(event.target.getAttribute('data-index'), 10) == index) {

        if (delay || options.autoRestart) restart();

        options.transitionEnd && options.transitionEnd.call(event, position, slides[index]);

      }

    }

  };

  // trigger setup
  setup();

  // start auto slideshow if applicable
  if (delay) begin();


  // add event listeners
  if (browser.addEventListener) {


    // We need to add the listeners on the prev and next buttons if the specific DOM ids were sent when the Swipe object was instantiated
    // We keep them separated because a user might want to add only one button (either next or prev)
    if (options.btnNextClass) {

      var nextButton = container.querySelector(options.btnNextClass);

      addEventHandler(nextButton,"click",function(e){
        e.preventDefault();
        offloadFn(stop.call());
        offloadFn(next.call());
      });

    }

    if (options.btnPrevClass) {

      var prevButton = container.querySelector(options.btnPrevClass);

      addEventHandler(prevButton,"click",function(e){
        e.preventDefault();
        offloadFn(stop.call());
        offloadFn(prev.call());
      });

    }

    if (options.bulletWrapperClass) {

      var bulletWrap = container.querySelector(options.bulletWrapperClass);

      addEventHandler(bulletWrap,"click",function(e){
        if (getTarget(e).innerHTML) {
          var slideNumber = parseInt(getTarget(e).innerHTML);
          if (!isNaN(slideNumber)) {
            e.preventDefault();
            offloadFn(stop.call());
            offloadFn(slide(slideNumber));
          }
        }
      });

    }


    // set touchstart event on element
    if (browser.touch) element.addEventListener('touchstart', events, false);

    if (browser.transitions) {
      element.addEventListener('webkitTransitionEnd', events, false);
      element.addEventListener('msTransitionEnd', events, false);
      element.addEventListener('oTransitionEnd', events, false);
      element.addEventListener('otransitionend', events, false);
      element.addEventListener('transitionend', events, false);
    }

    // set resize event on window
    window.addEventListener('resize', events, false);

  } else {

    window.onresize = function () { setup() }; // to play nice with old IE

  }

  // expose the Swipe API
  return {
    setup: function() {

      setup();

    },
    slide: function(to, speed) {

      // cancel slideshow
      stop();

      slide(to, speed);

    },
    prev: function() {

      // cancel slideshow
      stop();

      prev();

    },
    next: function() {

      // cancel slideshow
      stop();

      next();

    },
    restart: function() {

      // Restart slideshow
      restart();

    },
    stop: function() {

      // cancel slideshow
      stop();

    },
    getPos: function() {

      // return current index position
      return position;

    },
    getNumSlides: function() {

      // return total number of slides
      return length;
    },
    kill: function() {

      // cancel slideshow
      stop();

      // reset element
      element.style.width = '';
      element.style.left = '';

      // reset slides
      var pos = slides.length;
      while (pos--) {

        var slide = slides[pos];
        slide.style.width = '';
        slide.style.left = '';

        if (browser.transitions) translate(pos, 0, 0);

      }

      // removed event listeners
      if (browser.addEventListener) {

        // remove current event listeners
        element.removeEventListener('touchstart', events, false);
        element.removeEventListener('webkitTransitionEnd', events, false);
        element.removeEventListener('msTransitionEnd', events, false);
        element.removeEventListener('oTransitionEnd', events, false);
        element.removeEventListener('otransitionend', events, false);
        element.removeEventListener('transitionend', events, false);
        window.removeEventListener('resize', events, false);

      }
      else {

        window.onresize = null;

      }

    }
  }

}


(function (factory) {
  if(typeof module === "object" && typeof module.exports === "object") {
    factory(require("jquery"), window, document);
  } else {
    factory(jQuery, window, document);
  }
}(function($, window, document, undefined) {
  if ( window.jQuery || window.Zepto ) {
    (function($) {
      $.fn.Swipe = function(params) {
        return this.each(function() {
          $(this).data('Swipe', new Swipe($(this)[0], params));
        });
      }
    })( window.jQuery || window.Zepto )
  }
}));

},{"jquery":"/root/app-home/node_modules/browserify/lib/_empty.js"}]},{},["./src/public/logged-out-mobile.js"])
//# sourceMappingURL=data:application/json;base64,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
